import {People} from "@mui/icons-material"
import i18n from 'i18next';

// ==============================|| DASHBOARD MENU ITEMS ||============================== //


const getCustomerForgotPassword = () => ({
    id: 'customerForgotPassword',
    type: 'group',
    children: [
        {
            id: 'customerForgotPassword',
            title: i18n.t('sidemenu.customerForgotPassword'),
            type: 'item',
            url: '/forgotPassword',
            icon: People,
            breadcrumbs: false,
        },
    ]
});

export default getCustomerForgotPassword;